export default __webpack_public_path__ + "static/media/sun.51d3dc8e.svg";